import ApiService from '../../../../../../services/ApiService'
import PieChart from '../../charts/barChart'
import { GChart } from 'vue-google-charts/legacy'
import TNoContent from '../../../../../../components/T/TNoContent.vue'

export default {
  props: {
    filterProp: Object,
  },

  async created() {
    this.listRequestsByCostCenter()
  },

  data: () => ({
    loading: false,
    showChart: true,
    page: 1,
    googleChartData: [],
    opt: {
      is3D: true,
    },
    totalPages: 1,
    pageSize: 14,
    haveResponse: false,
    costCenterNames: [],
    requestQuantity: [],
    backgroundColors: [
      '#426483',
      '#BBCF20',
      '#0F3565',
      '#212950',
      '#C4E8F2',
      '#ED8990',
      '#FDB578',
      '#7EE882',
    ],
    requestsByCostCenter: [],
    requestsByCostCenterChartData: {},
    options: {},
    filter: {},
    requestsByCostCenterHeader: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Centro de Custo',
        align: 'center',
        value: 'costCenter',
      },
      {
        text: 'Quantidade',
        align: 'center',
        value: 'quantity',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    total: 0,
  }),

  components: {
    PieChart,
    GChart,
    TNoContent,
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `requests_by_cost_center_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/requestsByCostCenter', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    fillRequestCostCenter() {
      this.requestsByCostCenterChartData = {
        labels: this.costCenterNames,
        datasets: [
          {
            label: this.$t('Solicitações'),
            backgroundColor: this.backgroundColors,
            data: this.requestQuantity,
          },
        ],
      }
    },

    fillOptions() {
      this.options = {
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: true,
          labels: {
            usePointStyle: true,
          },
        },
      }
    },

    async listRequestsByCostCenter() {
      await this.apiService
        .post('reports/requestsByCostCenter', this.filterProp)
        .then((response) => {
          this.total = response.content.total
          this.requestsByCostCenter = response.content.objects
          this.totalPages = response.content.pager.totalPages

          this.costCenterNames = []
          this.requestQuantity = []
          this.googleChartData = []

          this.showChart = response.content.objects.length > 0
          this.getBackgroundColors(response.content.chartsModel.length)

          this.haveResponse = response.content.chartsModel.length

          if (this.haveResponse) {
            response.content.chartsModel.map((chart) => {
              this.costCenterNames.push(chart.name)
              this.requestQuantity.push(chart.quantity)

              this.googleChartData.push([chart.name, chart.quantity])
            })

            this.googleChartData.unshift([
              this.$t('Nome do centro de custo'),
              this.$t('Quantidade solicitações'),
            ])
          }
        })
        .catch((err) => {})

      this.fillRequestCostCenter()
      this.fillOptions()
    },

    getBackgroundColors(length) {
      this.backgroundColors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        this.backgroundColors.push(
          `#${Math.floor(Math.random() * 16777215).toString(16)}`
        )
      }
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.listRequestsByCostCenter()
    },
  },
}
